import React from "react";

export function StarIcon({
  size = 16,
  color = "currentColor",
  style,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.39998 1.21375C7.64664 0.720417 8.35331 0.720417 8.59331 1.21375L10.1933 4.45375C10.2933 4.65375 10.48 4.78708 10.6933 4.82042L14.2666 5.34042C14.8133 5.42042 15.0333 6.09375 14.6333 6.48042L12.0466 9.00042C11.8866 9.15375 11.82 9.37375 11.8533 9.59375L12.4666 13.1538C12.56 13.7004 11.9866 14.1138 11.5 13.8538L8.30664 12.1738C8.11331 12.0738 7.87998 12.0738 7.68664 12.1738L4.49331 13.8538C4.00665 14.1138 3.43331 13.6938 3.52665 13.1538L4.13998 9.59375C4.17998 9.38042 4.10665 9.15375 3.94665 9.00042L1.35998 6.48042C0.966646 6.09375 1.17998 5.42042 1.72665 5.34042L5.29998 4.82042C5.51998 4.78708 5.70665 4.65375 5.79998 4.45375L7.39998 1.21375Z"
        fill="#FA982E"
      />
    </svg>
  );
}
